module.exports = __webpack_public_path__ + "static/media/web_page_2.8da9ba52.png";